import axios from "axios"
import type {
  IFindAdressByPostCodeRequest,
  IFindAdressByPostCodeResponse,
  IFindPostCodeRequest,
  IGetCoordinatesRequest,
  IGetCoordinatesResponse,
  IGetDetailsRequest,
  IGetDetailsResponse,
  IGetPaymentMethodsResponse,
  IRegisterOrderRequest,
  IRegisterTreeResponse,
  ISubscribeChristmasTreeRequest,
} from "./registerTree.model"

export const findPostCode = async (
  url: string,
  data: IFindPostCodeRequest,
): Promise<IGetPaymentMethodsResponse> => {
  const payload: IFindPostCodeRequest = data
  const response = await axios.post<IGetPaymentMethodsResponse>(url, payload)

  return response.data
}

export const subscribeChristmasTree = async (
  url: string,
  data: ISubscribeChristmasTreeRequest,
): Promise<IGetPaymentMethodsResponse> => {
  const payload: ISubscribeChristmasTreeRequest = data
  const response = await axios.post<IGetPaymentMethodsResponse>(url, payload)

  return response.data
}

export const getAddressSuggestionsByPostCode = async (
  data: IFindAdressByPostCodeRequest,
): Promise<IFindAdressByPostCodeResponse> => {
  const payload: IFindAdressByPostCodeRequest = data

  const response = await axios.get<IFindAdressByPostCodeResponse>(
    `/umbraco/api/collections/address/search/${payload.postCode}`,
  )

  return response.data
}

export const getAdressDetails = async (data: IGetDetailsRequest): Promise<IGetDetailsResponse> => {
  const payload: IGetDetailsRequest = data

  const response = await axios.get<IGetDetailsResponse>(
    `/umbraco/api/collections/address/details`,
    {
      params: payload,
    },
  )

  return response.data
}
export const registerOrder = async (
  url: string,
  data: IRegisterOrderRequest,
): Promise<IRegisterTreeResponse> => {
  const payload: IRegisterOrderRequest = data
  const response = await axios.post<IRegisterTreeResponse>(url, payload)

  return response.data
}

export const getCoordinates = async (
  data: IGetCoordinatesRequest,
): Promise<IGetCoordinatesResponse> => {
  const url = "/umbraco/api/collections/address/coordinates"
  const payload: IGetCoordinatesRequest = data
  const response = await axios.get<IGetCoordinatesResponse>(url, { params: payload })

  return response.data
}
